<template>
  <PublicPopup ref="PopupRef" :closeable="false">
    <template #content>
      <div class="maintain-popup">
        <div class="images-box">
          <!-- <img src="" alt=""> -->
        </div>
        <div class="desc">
          <p>Prezados usuários,</p>
          <p>Olá!</p>
          <p>
            Tenho o prazer de informar que vamos parar o servidor e atualizar a versão principal
            V7.0! O serviço será descontinuado nos próximos horários, então, por favor, aguarde
            novos recursos! Se o prazo for encurtado ou estendido, notificaremos vocês
            separadamente.
          </p>
          <p>
            Suspensão de serviço inicia: 04/01/2026 02:00:00; Suspensão no fim do serviço:
            04/01/2026 07:00:00 (cerca de 5 horas)ounovoaviso;
          </p>
          <p>
            Conteúdo envolvido: todas as funções do lobby web, todas as "funções do lobby do APP,
            estação de download e estação de" "promoção, e todos os jogos."
          </p>
          <p>Se isso te causar algum incômodo, por favor, me perdoe!</p>
        </div>
      </div>
    </template>
  </PublicPopup>
</template>

<script setup>
const PopupRef = ref(null)
const open = () => {
  nextTick(() => {
    PopupRef.value.open()
  })
}

defineExpose({
  open,
})
</script>

<style lang="scss" scoped>
.maintain-popup {
  height: 60vh;
  overflow-y: auto;

  .images-box {
    height: 200px;
  }

  .desc {
    font-size: 14px;
    color: var(--maintain-popup-content-text);
    line-height: 1.5;
  }
}
</style>
